import { Modal } from '@sb1/ffe-modals-react';
import { useProject } from '../../project-hooks/useProject';
import FacebookShareInstructionsModalBlock from './FacebookShareInstructionsModalBlock';

export default function FacebookShareInstructionsModal({
    ref,
    urlToShare,
    trackingProperties,
    showBackButton = true,
    tradingCardImageUrl,
}) {
    const project = useProject();
    return (
        <Modal ref={ref} ariaLabelledby={'share-modal-title'}>
            <FacebookShareInstructionsModalBlock
                ref={ref}
                urlToShare={urlToShare}
                project={project}
                trackingProperties={trackingProperties}
                onBack={showBackButton ? () => ref?.current?.close() : undefined}
                tradingCardImageUrl={tradingCardImageUrl}
            />
        </Modal>
    );
}
